import { BeamNetworkCallEvent } from "./events";

/**
 * Fetch Listener
 */

const fetchHandler = {
  apply: function (target: any, _thisArg: any, args: any[]) {
    return target(...args).then((response: Response) => {
      if (response.ok && networkListenersEnabled) {
        const responseCopy = response.clone();
        window.dispatchEvent(
          new BeamNetworkCallEvent({
            url: args[0].toString(),
            method: (args[1]?.method || "get").toLowerCase(),
            type: "fetch",
            response: responseCopy,
          }),
        );
      }
      return response;
    });
  },
};

/**
 * XMLHTTPRequest Listener
 */
const xhrHandler = {
  construct(TargetConstructor: any, args: any[]) {
    const xhr: XMLHttpRequest = new TargetConstructor(...args);
    const _open: (method: string, url: string | URL) => void = xhr.open;
    let _method: string;
    let _url: string | URL;

    xhr.open = function (method: string, url: string | URL) {
      _method = method;
      _url = url;
      // @ts-expect-error arguments is untyped since xhr.open is an overloaded method
      // eslint-disable-next-line prefer-rest-params
      _open.apply(this, arguments);
    };

    // The enabled flag is checked at dispatch time (inside the load callback),
    // so XHRs constructed before an opt-out also go quiet once torn down.
    xhr.addEventListener("load", () => {
      if (!networkListenersEnabled) return;
      window.dispatchEvent(
        new BeamNetworkCallEvent({
          url: (_url || "").toString(),
          method: (_method || "get").toLowerCase(),
          type: "xhr",
          xhr,
        }),
      );
    });

    return xhr;
  },
};

/**
 * Side-Effects Setup (initialize listeners)
 */

let initializedListeners = false; // Proxies installed once, ever (never un-patched)
let networkListenersEnabled = false; // whether the Proxies currently dispatch Beam events

export const initNetworkListeners = () => {
  networkListenersEnabled = true;

  if (initializedListeners) return; // Proxies already installed; dispatching just re-enabled
  window.fetch = new Proxy(window.fetch, fetchHandler);
  XMLHttpRequest = new Proxy(XMLHttpRequest, xhrHandler);
  initializedListeners = true;
};

/**
 * Disables Beam event dispatching from the fetch/XHR Proxies without
 * un-patching them (un-patching is unsafe if another script wrapped
 * fetch/XHR after us — restoring our saved reference would remove
 * their wrapper too).
 */
export const teardownNetworkListeners = () => {
  networkListenersEnabled = false;
};
